import { Box, styled } from '@mui/material';
import { DateTimePicker, TimePicker } from '@mui/x-date-pickers';

export const CustomDateTimePicker = styled(DateTimePicker)(({ theme, size }) => ({
  width: size === 'large' ? '180px' : '110px',
  textAlign: 'right',

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    color: theme.colors.blue,
    borderRadius: '6px',
    justifySelf: 'flex-end',
    height: '38px',
    fontSize: '17px',
    background: theme.colors.softGray,
    padding: '0',
    border: 'none',
  },

  // Hide calendar icon
  '& .MuiInputAdornment-root': {
    display: 'none',
  },
}));

export const CustomTimePicker = styled(TimePicker)(({ theme, size }) => ({
  width: size === 'large' ? '180px' : '110px',
  textAlign: 'right',

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    color: theme.colors.blue,
    borderRadius: '6px',
    justifySelf: 'flex-end',
    height: '38px',
    fontSize: '17px',
    background: theme.colors.softGray,
    padding: '0',
    border: 'none',
  },

  // Hide calendar icon
  '& .MuiInputAdornment-root': {
    display: 'none',
  },
}));

export const ItemBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.colors.borderBottom}`,
  '&:last-child': {
    borderBottom: 'none',
  },
}));
